import { Pipe, PipeTransform } from '@angular/core';
import { aciesDateFormat } from '@shared/helpers';

@Pipe({
	name: 'aciesDateFormat',
	pure: true,
	standalone: false,
})
export class AciesDateFormatPipe implements PipeTransform {
	transform(value: Date | number | string, withTime: boolean = true, withSeconds: boolean = false): string {
		if (!value) return '';
		let date: Date;
		if (value instanceof Date) {
			date = value;
		} else if (typeof value === 'number') {
			date = new Date(value);
		} else {
			date = new Date(Date.parse(value));
		}
		return aciesDateFormat(date, withTime, withSeconds);
	}
}
